import { MutationTree } from 'vuex';
import { RootState } from './types';
import { save } from '@/helpers/storage';
import { momentTZ as moment } from '@/helpers/moment';
import { event } from 'vue-analytics';
import { PackageGroup } from '@/models/packagegroup';
import { Package } from '@/models/package';
import { Address } from '@/models/address';
import { Account } from '../auth/types';
import { Order } from '@/models/order';
import { ServiceMatrix } from '@/models/serviceMatrix';
import { Warehouse } from '@/models/warehouse';
import { WarehousePackage } from '@/models/warehousePackage';
import { AccountAgent } from '@/models/account';

const mutations: MutationTree<RootState> = {
  setState(state: RootState, val: any) {
    if (typeof val === 'object' && val.val) {
      state.state = val.val + (val.err ? ' ' + val.err : '');
    } else {
      state.state = String(val);
    }
  },

  clearState(state: RootState) {
    state.state = '';
  },

  setLastErr(state: RootState, err: any) {
    state.lastErr = err;
    event('root-store', 'commit-setLastErr', err);
  },

  setTZName(state: RootState, payload: string) {
    state.timezone = payload;
    event('root-store', 'commit-setTZName', payload);
  },
  setGlobalSelectedAccount(state: RootState, acc?: Account) {
    state.globalSelectedAccount = acc;
  },

  setPackageGroups(state: RootState, packageGroups: PackageGroup[]) {
    state.packageGroups = packageGroups;
  },
  setPackages(state: RootState, packages?: Package[]) {
    if (packages) { state.packages = packages; }

    const pp = [];
    for (const pg of state.packageGroups) {
      for (const p of pg.packages) {
        pp.push(p);
      }
    }
    state.packages = pp;
  },
  setViews(state: RootState, views: any) {
    state.views = views;
  },
  setSalesAgents(state: RootState, agents: AccountAgent[]) {
    state.salesConsultants = agents;
  },

  setServiceMatrices(state: RootState, rows: ServiceMatrix[]) {
    state.serviceMatrix = rows;
  },

  setWarehouses(state: RootState, rows: Warehouse[]) {
    state.warehouses = rows;
  },

  setWarehousePackages(state: RootState, rows: WarehousePackage[]) {
    state.warehousepackages = rows;
  },

  setSnackbarState(state: RootState, val: boolean) {
    state.snackbarState = val;
  },

  showSnack(state: RootState, text: string) {
    state.snackbarState = true;
    state.snackbarText = text;
  }
};

export default mutations;
